module.exports = __webpack_public_path__ + "img/comedor.e40d10d3.svg";